import Shipment from '@features/Shipment/ui/Shipment';

export default function ShipmentPage() {
  return <Shipment />;
}
